/**
 * Presentational field components for displaying labeled values in detail views.
 *
 * Components:
 *   ReadOnlyField (exported) — renders a label/value pair with uppercase label styling;
 *                               falls back to 'N/A' when the value is empty.
 *   AppInfoField  (exported) — renders a label/value pair with an optional leading icon;
 *                               displays an 'N/A' placeholder when the value is null or undefined.
 */

import type {ReactNode} from 'react';

export const ReadOnlyField = ({label, value}: {label: string; value: ReactNode}) => (
  <div>
    <div className='text-xs font-semibold text-brand-gray uppercase tracking-wider'>{label}</div>
    <div className='text-brand-navy font-medium break-words'>{value || 'N/A'}</div>
  </div>
);

export const AppInfoField = ({
  label,
  value,
  icon,
}: {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
}) => (
  <div>
    <p className='text-xs font-medium text-muted-foreground uppercase tracking-wider mb-1'>
      {label}
    </p>
    <div className='flex items-center gap-1.5'>
      {icon}
      <span className='text-sm font-medium text-brand-navy'>
        {value !== null && value !== undefined ? (
          value
        ) : (
          <span className='text-muted-foreground'>N/A</span>
        )}
      </span>
    </div>
  </div>
);
